import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, ViewEncapsulation, WritableSignal, inject, signal } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { PrefixPipe } from '@pipes/prefix.pipe';
import { firstValueFrom } from 'rxjs';
import { SpacerComponent } from 'src/app/common/components/spacer/spacer.component';
import { ApiCallModule } from 'src/app/common/directives/api-call.module';
import { SdValueInjectorDirective } from 'src/app/common/directives/sd-value-injector.directive';
import { WritableApiSignal, toWritableApiSignal } from 'src/app/common/util/api-signal';
import { ShadowStylesDirective } from 'src/boilerplate/shadow-styles.directive';
import { NotificationSettings, SettingsService } from 'src/openapi-client';

@Component({
  selector: 'wct-profile-notification-settings',
  standalone: true,
  imports: [CommonModule, SpacerComponent, TranslocoModule, PrefixPipe, SdValueInjectorDirective, ApiCallModule],
  templateUrl: './profile-notification-settings.component.html',
  styleUrls: ['./profile-notification-settings.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  hostDirectives: [ShadowStylesDirective],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class ProfileNotificationSettingsComponent {
  protected notificationSettings = Object.values(NotificationSettings);
  protected readonly settings: WritableApiSignal<NotificationSettings> = toWritableApiSignal(
    inject(SettingsService).loadNotificationSettings()
  );
  protected readonly loading: WritableSignal<boolean> = signal(false);
  protected readonly viaEmailTranslationString: string = 'profile.notificationSettings.viaEmail';
  protected readonly inPortalTranslationString: string = 'profile.notificationSettings.inPortal';

  private readonly settingsService: SettingsService = inject(SettingsService);

  protected async onNotificationChanged(event: Event): Promise<void> {
    if (this.loading()) {
      return;
    }
    this.settings.set((event as any).target.value);
    this.loading.set(true);
    try {
      await firstValueFrom(this.settingsService.saveNotificationSettings(this.settings()));
    } finally {
      this.loading.set(false);
    }
  }
}
